import styled, {css} from 'styled-components';

export const formGrid = css`
	--gap: var(--spacing-xx-large);
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	grid-template-rows: auto;
	grid-template-areas:
		'userSettings userSettings userSettings userSettings userSettings'
		'firstName firstName lastName lastName .'
		'displayLanguage displayLanguage . . .'
		'dateFormat . . . .'
		'numberFormat . . . .'
		'timeZone timeZone . . .'
		'theme theme theme theme theme'
		'themeSelector . . . .';
	min-height: 0;
	gap: var(--gap);
	padding: var(--spacing-xx-large) 0;

	& > .userSettings {
		grid-area: userSettings;
	}

	& > .firstName {
		grid-area: firstName;
	}

	& > .lastName {
		grid-area: lastName;
	}

	& > .displayLanguage {
		grid-area: displayLanguage;
	}

	& > .dateFormat {
		grid-area: dateFormat;
	}

	& > .numberFormat {
		grid-area: numberFormat;
	}

	& > .timeZone {
		grid-area: timeZone;
	}

	& > .theme {
		grid-area: theme;
		display: flex;
		flex-direction: column;
	}

	& > .themeSelector {
		grid-area: themeSelector;
	}
`;

export default styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	& > .customScrollbar {
		padding: 0 var(--template-padding-sides);
		flex: 1;
		& > .grid {
			${formGrid}
		}
	}
	& > footer {
		background: var(--neutrals-bg-gradient1);
		border-top: var(--template-separator);
		flex-shrink: 0;
		display: flex;
		gap: var(--spacing-large);
		padding: var(--spacing-medium) var(--template-padding-sides);
		justify-content: flex-end;
	}
`;
